const updateRow = ({ object, key, items }) => {
  const {
    name,
    description,
  } = object;

  return items.map(item =>
    item.id === key ? { ...item, name, description } : item
  );
}

export default updateRow;
